// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"TreatmentInput_item-container__2D-KX","itemBox":"TreatmentInput_item-box__3Irav"};